import { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { X, ArrowUpRight } from 'lucide-react';
import { shopProducts } from '../shopData';
import { useUI } from '../context/UIContext';
import '../styles/merch-popup.css';

const promoImage = (shopProducts.find(item => item.id === 'felpa-cappuccio-verde') || shopProducts[0]).image;

export const MerchPopup = () => {
  const { lenis } = useUI();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem('f100_merch_popup')) return;
    const timer = setTimeout(() => setOpen(true), 5000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (open) { lenis.current?.stop(); document.body.style.overflow = 'hidden'; sessionStorage.setItem('f100_merch_popup', '1'); } else { lenis.current?.start(); document.body.style.overflow = ''; }
    return () => { document.body.style.overflow = ''; };
  }, [open, lenis]);

  useEffect(() => {
    const onKey = (event) => { if (event.key === 'Escape') setOpen(false); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, []);

  return <AnimatePresence>{open && (
    <motion.div className="merch-popup-overlay" data-testid="merch-popup" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.35 }} onClick={() => setOpen(false)}>
      <motion.div className="merch-popup" role="dialog" aria-modal="true" aria-label="Novità Merch Fantasti100" initial={{ opacity: 0, y: 44, scale: 0.96 }} animate={{ opacity: 1, y: 0, scale: 1 }} exit={{ opacity: 0, y: 24, scale: 0.97 }} transition={{ duration: 0.55, ease: [0.16, 1, 0.3, 1] }} onClick={(event) => event.stopPropagation()}>
        <button className="merch-popup-close" onClick={() => setOpen(false)} aria-label="Chiudi" data-testid="merch-popup-close"><X size={20} /></button>
        <div className="merch-popup-media"><img src={promoImage} alt="Merchandising ufficiale Fantasti100" /></div>
        <div className="merch-popup-body">
          <span className="eyebrow merch-popup-eyebrow" data-testid="merch-popup-eyebrow">NUOVO · MERCH FANTASTI100</span>
          <h2 className="merch-popup-title" data-testid="merch-popup-title">Indossa<br /><em>la passione.</em></h2>
          <p className="merch-popup-text">Felpe, t-shirt, giacche e accessori ufficiali. Scopri la collezione e porta i Fantasti100 sempre con te.</p>
          <Link to="/shop" className="button button-gold merch-popup-cta" onClick={() => setOpen(false)} data-testid="merch-popup-cta">SCOPRI IL MERCH <ArrowUpRight size={19} /></Link>
        </div>
      </motion.div>
    </motion.div>
  )}</AnimatePresence>;
};
